import $ from 'jquery';
import 'slick-carousel';

export function slick() {
  $('.crf-hero_images > ul').slick({
    dots: false,
    infinite: true,
    autoplay: true,
    pauseOnFocus: false,
    pauseOnHover: false,
    pauseOnDotsHover: false,
    prevArrow: '<li class="c-hover p-content-slide__arrow--prev"></li>',
    nextArrow: '<li class="c-hover p-content-slide__arrow--next"></li>',
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    cent1erMode: false,
    variableWidth: false,
    lazyLoad: 'progressive',
  });

  /*
        リサイズすると、次のスライドの画像が見切れるので、リサイズ中はis-resizeはを付与して、次のスライドをopacity:0にする。
        ただし、常時opacity:0だと3枚目から1枚目に変化する時に挙動が不自然になるので、リサイズ終了後はクラスを削除してopacityを初期値に戻す。
    */
  let timer_riseze = null;
  $(window).on('resize', function () {
    $('.slick-slide').addClass('is-resize');
    if (timer_riseze !== null) {
      clearTimeout(timer_riseze);
    }
    timer_riseze = setTimeout(function () {
      $('.slick-slide').removeClass('is-resize');
    }, 200);
  });

  //1つめのスライダー
  $('.crf-custom-slide')
    .on('init', function (event, slick) {
      $(this).append(
        '<div class="slick-counter"><span class="current1"></span><span class="total total1"></span></div>'
      );
      $('.current1').text(slick.currentSlide + 1);
      $('.total1').text(slick.slideCount);
    })
    .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      $('.current1').text(nextSlide + 1);
    });
  //1つめのスライダー
  $('.crf-custom-slide')
    .on('breakpoint', function (event, slick) {
      $(this).append(
        '<div class="slick-counter"><span class="current1"></span><span class="total total1"></span></div>'
      );
      $('.current1').text(slick.currentSlide + 1);
      $('.total1').text(slick.slideCount);
    })
    .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      $('.current1').text(nextSlide + 1);
    });

  $('.crf-custom-slide').slick({
    dots: true,
    infinite: true,
    autoplay: false,
    prevArrow: '<li class="c-hover p-content-slide__arrow--prev"></li>',
    nextArrow: '<li class="c-hover p-content-slide__arrow--next"></li>',
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    variableWidth: true,
    centerMode: true,
    lazyLoad: 'progressive',
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  //2つめのスライダー
  $('.crf-custom-slide_2')
    .on('init', function (event, slick) {
      $(this).append(
        '<div class="slick-counter"><span class="current2"></span><span class="total total2"></span></div>'
      );
      $('.current2').text(slick.currentSlide + 1);
      $('.total2').text(slick.slideCount);
    })
    .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      $('.current2').text(nextSlide + 1);
    });

  $('.crf-custom-slide_2')
    .on('breakpoint', function (event, slick) {
      $(this).append(
        '<div class="slick-counter"><span class="current2"></span><span class="total total2"></span></div>'
      );
      $('.current2').text(slick.currentSlide + 1);
      $('.total2').text(slick.slideCount);
    })
    .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      $('.current2').text(nextSlide + 1);
    });

  //2つのスライダーが連動してしまうため、同じ内容だが2回記述する
  $('.crf-custom-slide_2').slick({
    dots: true,
    infinite: true,
    autoplay: false,
    prevArrow: '<li class="c-hover p-content-slide__arrow--prev"></li>',
    nextArrow: '<li class="c-hover p-content-slide__arrow--next"></li>',
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    variableWidth: true,
    lazyLoad: 'progressive',
    centerMode: true,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
}
